







































import { Component, Vue } from "vue-property-decorator";
import { Button, Icon, Dialog } from "vant";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

@Component({
  name: "AccountIndex",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component
  }
})
export default class AccountIndex extends Vue {
  toGetFun() {
    window.location.href = (browser.getH5Url?browser.getH5Url+'/personal':false) || (window as any).$config.VUE_APP_GET_URL;
  }
  handleOpen() {
    const token = sessionStorage.getItem("token");
    if(!token){// 未登录
      this.$router.push({ name: 'loginH5' });
      return
    }
    // 获取开户状态
    (this as any).$apis
      .getAccountStatus()
      .then(res => {
        const { is_open_account, is_verify } = res;
        if(is_open_account || is_verify === 0){
          Dialog.alert({
            title: '提示',
            confirmButtonText: '知道了',
            message: '系统检测到您已提交申请，请不要重复提交',
          }).then(() => {
            // on close
          });
          return
        }
        this.$router.push({name: 'ModeSelect'})
      })
      .catch(e => {
        
      });
  }
}
